import { Component } from '@angular/core';

import { MonitoringService } from '@core/services/monitoring.service';
import { ReportAbstract } from '@features/reports/abstracts/report.abstract';
import { ReportsService } from '@features/reports/services/reports.service';
import { Report } from '@shared/enums/report.enum';

interface EmailCampaignMetricsSummary {
  canvasName: string;
  sendCount: number;
  deliveredCount: number;
  openCount: number;
  clickCount: number;
  unsubscribeCount: number;
  bounceCount: number;
}

@Component({
  templateUrl: './canvas-metrics.component.html',
  styleUrls: ['./canvas-metrics.component.scss']
})
export class EmailCampaignMetricsReportComponent extends ReportAbstract<EmailCampaignMetricsSummary> {
  title = 'Email Campaign Metrics';
  reportName = Report.EmailCampaignMetrics;
  columns = [
    { name: 'Email Campaign Name', prop: 'canvasName' },
    { name: 'Sent', prop: 'sendCount' },
    { name: 'Delivered', prop: 'deliveredCount' },
    { name: 'Opened', prop: 'openCount' },
    { name: 'Clicked', prop: 'clickCount' },
    { name: 'Unsubscribed', prop: 'unsubscribeCount' },
    { name: 'Bounced', prop: 'bounceCount' }
  ];
  csvHeaders = [
    {
      label: 'Email Campaign Name',
      value: 'canvasName'
    },
    {
      label: 'Sent Count',
      value: 'sendCount'
    },
    {
      label: 'Delivered Count',
      value: 'deliveredCount'
    },
    {
      label: 'Open Count',
      value: 'openCount'
    },
    {
      label: 'Click Count',
      value: 'clickCount'
    },
    {
      label: 'Unsubscribe Count',
      value: 'unsubscribeCount'
    },
    {
      label: 'Bounce Count',
      value: 'bounceCount'
    }
  ];

  constructor(
    reportsService: ReportsService,
    monitoringService: MonitoringService
  ) {
    super(Report.EmailCampaignMetrics, reportsService, monitoringService);
  }
} 